<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="1">
        <v-select
          v-model="filterTruckType"
          label="Truck Type"
          :items="truckTypes"
          item-text="name"
          item-value="id"
          hide-details="true"
          :loading="loadingTruckTypes"
          clearable
        >
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
          <!-- eslint-disable-next-line vue/no-template-shadow -->
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
        </v-select>
      </v-col>
      <v-col
        v-if="isAdmin || isDeliveriesManager"
        class="text-end pb-0 pt-7"
      >
        <v-btn
          color="primary"
          outlined
          @click="openTruckForm()"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          NEW TRUCK
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="itemsTableFooterProps"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            :loading="loading"
            dense
            fixed-header
            :height="windowHeight"
            :server-items-length="total"
            @update:options="updateOptions"
          >
            <template #[`item.id`]="{ item }">
              <text-highlight :queries="search">
                {{ item.id ? item.id : '-' }}
              </text-highlight>
            </template>
            <template #[`item.name`]="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                :color="item && item.color ? item.color : 'grey'"
              >
                <text-highlight :queries="search">
                  {{ item.name ? item.name : '-' }}
                </text-highlight>
              </v-chip>
            </template>
            <template #[`item.type_name`]="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                :color="item && item.type && item.type.color ? item.type.color : 'grey'"
              >
                <text-highlight :queries="search">
                  {{ item.type.name ? item.type.name : '-' }}
                </text-highlight>
              </v-chip>
            </template>
            <template #[`item.type_weight_limit`]="{ item }">
              <text-highlight :queries="search">
                {{ item.type_weight_limit ? item.type_weight_limit : '-' }}
              </text-highlight>
            </template>
            <template #[`item.plate_number`]="{ item }">
              <text-highlight :queries="search">
                {{ item.plate_number ? item.plate_number : '-' }}
              </text-highlight>
            </template>
            <template #[`item.truck_number`]="{ item }">
              <text-highlight :queries="search">
                {{ item.truck_number ? item.truck_number : '-' }}
              </text-highlight>
            </template>
            <template #[`item.is_enabled`]="{ item }">
              <v-chip
                v-if="item.is_enabled === 1"
                small
                color="success"
                text-color="white"
              >
                ENABLED
              </v-chip>
              <v-tooltip
                  v-else
                  left
                  color="black"
                >
                  <template #activator="{ on }">
                    <v-chip
                      small
                      color="error"
                      text-color="white"
                      v-on="on"
                    >
                      DISABLED
                    </v-chip>
                  </template>
                  <span>{{ item.disabled_reason }}</span>
                </v-tooltip>
            </template>
            <template #[`item.actions`]="{ item }">
              <!-- <v-btn
                class="ml-1 mt-1 mb-1"
                :color="item.is_enabled === 1 ? 'purple' : 'success'"
                outlined
                small
                @click="setIsEnabled(item.id)"
              >
                {{ item.is_enabled === 1 ? 'DISABLE' : 'ENABLE' }}
              </v-btn> -->
              <v-btn
                v-if="item.is_enabled === 0 && (isAdmin || isDeliveriesManager)"
                class="ml-1 mt-1 mb-1"
                color="success"
                outlined
                small
                @click="enable(item.id)"
              >
                ENABLE
              </v-btn>
              <v-btn
                v-if="item.is_enabled === 1 && (isAdmin || isDeliveriesManager)"
                class="ml-1 mt-1 mb-1"
                color="purple"
                outlined
                small
                @click="disable(item.id)"
              >
                DISABLE
              </v-btn>
              <v-btn
                v-if="isAdmin || isDeliveriesManager"
                class="ml-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="openEditTruckForm(item.id)"
              >
                EDIT
              </v-btn>
              <v-btn
                v-if="isAdmin || isDeliveriesManager"
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="deleteTruck(item.id)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <truck-schedule-truck-form
      ref="truckForm"
      @success="get"
    />
    <confirm-form ref="confirmForm"/>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TruckScheduleTruckForm from '@/components/forms/truckSchedules/TruckScheduleTruckForm';

export default {
  components: {
    TruckScheduleTruckForm,
  },
  data: () => ({
    loading: false,
    loadingTruckTypes: false,
    itemsTableFooterProps: {
      'items-per-page-options': [50, 100, 500, -1],
    },
    headers: [
      { text: 'Truck ID', value: 'id', align: 'center', width: '5%' },
      { text: 'Name', value: 'name', align: 'center' },
      { text: 'Truck Type', value: 'type_name', align: 'center' },
      { text: 'Weight Limit (kg)', value: 'type_weight_limit' },
      { text: 'Plate Number', value: 'plate_number' },
      { text: 'Truck Number', value: 'truck_number' },
      { text: 'Status', value: 'is_enabled', align: 'center', sortable: false },
      // { text: 'Color', value: 'color' },
      // { text: 'Created At', value: 'created_at' },
      // { text: 'Created By', value: 'user_full_name' },
      {
        text: 'Actions', value: 'actions', width: '15%', align: 'end', sortable: false,
      },
    ],
    items: [],
    truckTypes: [],
    total: 0,
    pagination: {
      itemsPerPage: 100,
      page: 1,
    },
    sort: {
      order_by_first: 'type_name',
      direction_sort: true,
    },
    windowHeight: 1000,
    topSpaceHeight: 230,
    filterTruckType: null,

    roles: [],
    userRoleIdAdmin: 3,
    userRoleIdDeliveriesManager: 31,
    userRoleIdDeliveriesView: 33,
  }),
  computed: {
    ...mapGetters([
    ]),
    ...mapState({
      search: (state) => state.search,
      isDarkMode: 'isDarkMode',
      truckState: (state) => state.truckState,
      user: (state) => state.user,
    }),
    isAdmin() {
      return this.roles.includes(this.userRoleIdAdmin);
    },
    isDeliveriesManager() {
      return this.roles.includes(this.userRoleIdDeliveriesManager);
    },
    isDeliveriesView() {
      return this.roles.includes(this.userRoleIdDeliveriesView);
    },
  },
  watch: {
    pagination() {
      this.get();
    },
    search() {
      this.get();
    },
    filterTruckType() {
      this.get();
    },
  },
  created() {
    this.roles = this.user.roles.map((x) => x.id);
    if (this.truckState) {
      if (this.truckState.pagination) { this.pagination = this.truckState.pagination; }
      if (this.truckState.truck_type_id !== null) { this.statusId = this.truckState.truck_type_id; }
    }
    window.scrollTo(0, document.body.scrollHeight);
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    this.init();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    async init() {
      this.get();
      this.getTruckTypes();
    },

    storeState(property, value) {
      const state = this.truckState;
      state[property] = value;
      this.$store.commit('storeTruckState', state);
    },

    async get() {
      this.loading = true;
      this.items = [];
      this.total = 0;
      const submitModel = {
        filters: {
          truck_type_id: this.filterTruckType,
        },
        search: this.search,
        pagination: this.pagination,
        sort: this.sort,
      };
      const res = await this.$api.truckScheduleTruck.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res) {
        this.items = [];
        this.loading = false;
        return;
      }
      this.items = res;
      this.total = res.length ? res.length : 0;
      this.loading = false;
    },

    async getTruckTypes() {
      this.loadingTruckTypes = true;
      const submitModel = {
        filters: {
        },
      };
      this.truckTypes = await this.$api.truckScheduleTruckType.read(submitModel);
      this.loadingTruckTypes = false;
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;

      const res = await this.$api.truckScheduleTruck.delete(id);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    // async setIsEnabled(item) {
    //   const confirm = await this.$refs.confirmForm.open({
    //     title: `Are you sure you want to ${item.is_enabled === 1 ? 'Disable' : 'Enable'} this Truck?`,
    //   });
    //   if (!confirm) return;
    //   const isEnabled = item.is_enabled === 1 ? 0 : 1;
    //   const res = await this.$api.truckScheduleTruck.get(`enable/${item.id}/${isEnabled}`);
    //   if (!res) return;
    //   this.$bus.$emit('showSuccess');
    //   this.get();
    // },

    async enable(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure you want to enable this Truck?`,
      });
      if (!confirm) return;
      const res = await this.$api.truckScheduleTruck.get(`enable/${id}`);
      if (!res) return;
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async disable(id) {
      const reason = await this.$refs.confirmForm.open({
        title: `Are you sure you want to disable this Truck?`,
        withReason: true,
      });
      if (!reason) return;
      const submitModel = {
        disabled_reason: reason,
      };
      const res = await this.$api.truckScheduleTruck.update(submitModel, `disable/${id}`);
      if (!res) return;
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async deleteTruck(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      const res = await this.$api.truckScheduleTruck.delete(id);
      if (!res) return;
      this.$bus.$emit('showSuccess');
      this.get();
    },

    openTruckForm() {
      this.$refs.truckForm.open();
    },

    openEditTruckForm(id) {
      this.$refs.truckForm.open(id);
    },

    success() {
      this.get();
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
    },

    updateOptions(newOptions) {
      this.storeState('pagination', newOptions);
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      };
    },
  },
};
</script>
<style scoped>

::v-deep .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td
{
  padding-right: 4px !important;
  padding-left: 4px !important;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th
{
  padding-right: 4px !important;
  padding-left: 4px !important;
}
</style>
